// src/data/typography/fonts.js

export const NamefontFamilies = [
    { value: "Dancing Script, cursive", label: "Dancing Script" },
  { value: "Playfair Display, serif", label: "Playfair Display" }, 
    { value: "Cinzel Decorative, serif", label: "Cinzel Decorative" },
  { value: "Great Vibes, cursive", label: "Great Vibes" },
    { value: "Alex Brush, cursive", label: "Alex Brush" },
  { value: "Parisienne, cursive", label: "Parisienne" },
];

export const detailsfontFamilies = [
  { value: "Poppins, sans-serif", label: "Poppins" },
  { value: "Montserrat, sans-serif", label: "Montserrat" },
  { value: "Lora, serif", label: "Lora" },
  { value: "Merriweather, serif", label: "Merriweather" },
  { value: "Oswald, sans-serif", label: "Oswald" },
  { value: "Teko, sans-serif", label: "Teko" },
  { value: "Rajdhani, sans-serif", label: "Rajdhani" },
  { value: "Roboto, sans-serif", label: "Roboto" },
];

// pairingMap keys must exactly match the value strings you use above
export const pairingMap = {
  "Cinzel Decorative, serif": ["Poppins, sans-serif", "Lora, serif"],
  "Shrikhand, serif": ["Poppins, sans-serif", "Rajdhani, sans-serif"],
  "Great Vibes, cursive": ["Lora, serif", "Merriweather, serif"],
  "Dancing Script, cursive": ["Lora, serif", "Merriweather, serif"],
  "Yeseva One, cursive": ["Merriweather, serif", "Poppins, sans-serif"],
  "Parisienne, cursive": ["Lora, serif", "Libre Baskerville, serif"],
  "Playball, cursive": ["Montserrat, sans-serif", "Roboto, sans-serif"],
  "Charm, cursive": ["Lora, serif", "Merriweather, serif"],
  "Allura, cursive": ["Lora, serif", "Merriweather, serif"],
  "Alex Brush, cursive": ["Lora, serif", "Libre Baskerville, serif"],
  "'Cormorant Garamond', serif": ["Lora, serif", "Merriweather, serif"],
  "Playfair Display, serif": ["Lora, serif", "Merriweather, serif"],
  "Carter One, serif": ["Poppins, sans-serif", "Montserrat, sans-serif"],
  "Oswald, sans-serif": ["Roboto, sans-serif", "Rajdhani, sans-serif"],
  "Black Ops One, sans-serif": ["Roboto, sans-serif"],
};

 export const blessingfontFamilies = [
    { value: "Charm, cursive", label: "Charm" }, // elegant script, simple and warm
    { value: "Dancing Script, cursive", label: "Dancing Script" }, // joyful, soft curves .
    { value: "Allura, cursive", label: "Allura" }, // refined, looks premium .
    { value: "Alex Brush, cursive", label: "Alex Brush" }, // smooth calligraphy, classy .
    { value: 'Alice, serif', label: 'Alice' },
    { value: "Lato, sans-serif", label: "Lato" },
    { value: 'Roboto, sans-serif', label: 'Roboto' },
    { value: "Playfair Display, serif", label: "Playfair Display" }, // modern serif, premium magazine vibe
    { value: "Lora, serif", label: "Lora" }, // very readable and gentle for paragraphs
    { value: "Merriweather, serif", label: "Merriweather" }, // traditional and balanced
    //  { value: 'Montserrat, sans-serif', label: 'Montserrat' },
  ];

  export const fullNamefontFamilies = [
    { value: "'Yeseva One', cursive", label: "Yeseva One" }, // soft, stylish serif-cursive
    { value: "'Cinzel Decorative', serif", label: "Cinzel Decorative" }, // royal
    { value: "Prata, serif", label: "Prata" },
    { value: "Libre Baskerville, serif", label: "Libre Baskerville" },
    { value: "'Raleway', sans-serif", label: "Raleway" },
    { value: "'Cinzel', serif", label: "Cinzel" },
    { value: "'Playfair Display', serif", label: "Playfair Display" }, // luxury editorial
    { value: "Marcellus, serif", label: "Marcellus" }, // clean, minimal
  ];

  export const parentNamefontFamilies = [
    { value: "Lora, serif", label: "Lora" }, // timeless & warm
    { value: "Merriweather, serif", label: "Merriweather" }, // traditional and elegant
    { value: "'Cormorant Garamond', serif", label: "Cormorant Garamond" },
    { value: 'Roboto, sans-serif', label: 'Roboto' },
    { value: "'Playfair Display', serif", label: "Playfair Display" }, // premium, pairs well
    { value: "'Libre Baskerville', serif", label: "Libre Baskerville" },
    { value: "'Cormorant', serif", label: "Cormorant" },
    { value: "'Source Serif', serif", label: "Source Serif" }
  ];

  export const pairingMapParents = {
    "'Yeseva One', cursive": ["Lora, serif", "Merriweather, serif", "'Cormorant Garamond', serif"],
    "'Cinzel Decorative', serif": ["Lora, serif", "'Cormorant Garamond', serif", "'Source Serif', serif"],
    "Prata, serif": ["Lora, serif", "Merriweather, serif", "'Cormorant Garamond', serif"],
    "Libre Baskerville, serif": ["Lora, serif", "'Cormorant Garamond', serif"],
    "'Raleway', sans-serif": ["Roboto, sans-serif", "Lora, serif"],
    "'Cinzel', serif": ["Lora, serif", "'Cormorant', serif", "'Source Serif', serif"],
    "'Playfair Display', serif": ["Lora, serif", "Merriweather, serif", "'Libre Baskerville', serif"],
    "Marcellus, serif": ["Lora, serif", "'Cormorant Garamond', serif"],
  };

  export const specialfontFamilies = [
           { value: 'Alice, serif', label: 'Alice' },
            { value: "Lora, serif", label: "Lora" },
          { value: "'Playfair Display', serif", label: "Playfair Display" },
    { value: "'Libre Baskerville', serif", label: "Libre Baskerville" },
    { value: "Merriweather, serif", label: "Merriweather" },
    { value: "Prata, serif", label: "Prata" },
    { value: "Marcellus, serif", label: "Marcellus" },
    { value: "'Cinzel', serif", label: "Cinzel" },
      ];
